import React from 'react';

import {
  EventTriggeringConditionType,
  useFetchArtifactCollectionTriggersQuery,
  useFetchProjectTriggersQuery,
} from '../../generated/graphql';
import {CreateTriggerDrawer} from '../Launch/Triggers/CreateTriggerDrawer/CreateTriggerDrawer';
import {
  AddAliasTrigger,
  LinkModelTrigger,
} from '../Launch/Triggers/TriggerEventTypes';
import {SectionPlaceholder} from './SectionPlaceholder';

type CreateTriggerModalProps = {
  open: boolean;
  onClose: () => void;
  projectName: string;
  entityName: string;
  projectID: string;
  artifactCollectionID?: string;
};
export const CreateTriggerModal = ({
  open,
  onClose,
  projectName,
  entityName,
  projectID,
  artifactCollectionID,
}: CreateTriggerModalProps) => {
  const projectTriggersQuery = useFetchProjectTriggersQuery({
    variables: {projectName, entityName},
  });
  const collectionTriggersQuery = useFetchArtifactCollectionTriggersQuery({
    variables: {
      artifactCollectionID: artifactCollectionID ?? '',
    },
    skip: !artifactCollectionID,
  });
  const refetchProjectTriggers = projectTriggersQuery.refetch;
  const refetchCollectionTriggers = collectionTriggersQuery.refetch;
  const triggerEventOptions = [
    {
      label: LinkModelTrigger.text,
      value: EventTriggeringConditionType.LinkModel,
    },
    {
      label: AddAliasTrigger.text,
      value: EventTriggeringConditionType.AddArtifactAlias,
    },
  ];

  // TODO: Add link in the drawer to guide users to create a job if they haven't already?

  if (projectTriggersQuery.loading || collectionTriggersQuery.loading) {
    return <SectionPlaceholder />;
  }
  return (
    <CreateTriggerDrawer
      open={open}
      closeDrawer={onClose}
      projectName={projectName}
      entityName={entityName}
      projectID={projectID}
      refetchProjectTriggers={refetchProjectTriggers}
      refetchCollectionTriggers={refetchCollectionTriggers}
      customTriggerOptions={triggerEventOptions}
      artifactCollectionID={artifactCollectionID}
    />
  );
};
